import { SimpleList } from "@/components/list";

export const FAQS = [
  {
    title: "Why is Compliance Management important for businesses?",
    content: (
      <SimpleList
        points={[
          "Ensures legal and regulatory adherence, reducing compliance fines and security risks.",
          "Strengthens cybersecurity posture through continuous monitoring and policy enforcement.",
          "Automates audit readiness, simplifying security reporting.",
        ]}
      />
    ),
  },
  {
    title: "What industries require Compliance Management solutions?",
    content: (
      <SimpleList
        points={[
          "Healthcare – Requires . compliance for patient data protection.",
          "Finance & Banking – Must adhere to PCI-DSS, ISO 27001, and GDPR for secure transactions.",
          "E-Commerce & Retail – Needs PCI-DSS compliance for secure payment processing.",
        ]}
      />
    ),
  },
  {
    title: "How does AI improve compliance monitoring?",
    content: (
      <SimpleList
        points={[
          "AI-driven threat intelligence detects compliance risks before they escalate.",
          "Automated audits and risk assessments streamline regulatory reporting.",
          "SIEM-powered analytics flag anomalous activities that could violate compliance policies.",
        ]}
      />
    ),
  },
  {
    title: "What happens if my company fails a compliance audit?",
    content: (
      <SimpleList
        points={[
          "Regulatory fines and legal penalties may be imposed.",
          "Data security risks increase, exposing sensitive customer information.",
          "OneMind’s automated compliance tools help prevent audit failures and ensure ongoing adherence.",
        ]}
      />
    ),
  },
  {
    title: "How does SIEM help with compliance enforcement?",
    content: (
      <SimpleList
        points={[
          "Aggregates security logs from multiple sources to detect compliance violations.",
          "Correlates events and alerts security teams about risks in real-time.",
          "Provides forensic insights for post-incident compliance investigations.",
        ]}
      />
    ),
  },
  {
    title: "What are common compliance violations businesses face?",
    content: (
      <SimpleList
        points={[
          "Data breaches due to weak security policies.",
          "Failure to encrypt sensitive customer information.",
          "Unauthorized access to regulated data.",
          "Lack of security monitoring and audit logs.",
        ]}
      />
    ),
  },
  {
    title: "Can compliance audits be automated?",
    content: (
      <SimpleList
        points={[
          "Yes! OneMind automates compliance checks, audit logs, and security assessments to simplify regulatory adherence.",
        ]}
      />
    ),
  },
  {
    title: "How does SEC OPS optimize security compliance?",
    content: (
      <SimpleList
        points={[
          "Automates threat detection, incident response, and policy enforcement.",
          "Ensures security configurations meet compliance standards.",
          "Reduces human errors in security operations.",
        ]}
      />
    ),
  },
  {
    title: "How can businesses reduce compliance fines?",
    content: (
      <SimpleList
        points={[
          "Continuous compliance monitoring ensures regulatory adherence.",
          "Automated security audits prevent violations before audits occur.",
          "Real-time alerts detect and mitigate compliance risks proactively.",
        ]}
      />
    ),
  },
  {
    title: "What security frameworks does OneMind’s Compliance Management support?",
    content: (
      <SimpleList
        points={["GDPR, ., PCI-DSS, ISO 27001, NIST, SOC 2, and CIS benchmarks."]}
      />
    ),
  },
  {
    title: "Can OneMind integrate compliance tools with existing IT infrastructure?",
    content: (
      <SimpleList
        points={[
          "Yes! OneMind seamlessly integrates with SIEM, IAM, cloud security, and ITSM platforms.",
        ]}
      />
    ),
  },
  {
    title: "How does automated compliance management save time for IT teams?",
    content: (
      <SimpleList
        points={[
          "Eliminates manual security checks through AI-powered automation.",
          "Generates instant compliance reports to meet audit requirements.",
          "Reduces time spent on policy enforcement by automating security controls.",
        ]}
      />
    ),
  },
];
